<template>
  <b-navbar type="dark" variant="dark" class="top-nav-height">
    <div class="container">
      <b-navbar-nav class="ml-auto">
        <div class="federal-bar-links">
          <a role="button" @click="toggleLanguage">{{
            t("navbar.buttonText")
          }}</a>
        </div>
      </b-navbar-nav>
    </div>
  </b-navbar>
  <b-navbar toggleable type="dark" variant="dark" class="navbar-color p-3">
    <div class="container">
      <b-navbar-brand @click="notifyHome">
        <img
          src="../assets/content/img/Blue.png"
          class="bell-logo-margin-left"
          alt="bell logo"
          width="60"
          height="auto"
        />
      </b-navbar-brand>
    </div>
  </b-navbar>
</template>

<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import router from "@/router";
import { useStore } from "vuex";
const store = useStore();
const { locale } = useI18n();
const { t } = useI18n();

const toggleLanguage = () => {
  store.commit("setAuth", false);
  const newLocale = locale.value === "en" ? "fr" : "en";
  const currHost = window.location.host;
  const newHost =
    newLocale === "fr"
      ? process.env.VUE_APP_FRENCH_HOST != undefined
        ? process.env.VUE_APP_FRENCH_HOST
        : window.location.host
      : process.env.VUE_APP_ENGLISH_HOST != undefined
      ? process.env.VUE_APP_ENGLISH_HOST
      : window.location.host;
  const currentUrl = new URL(window.location.href);
  let newUrl = currentUrl.href.replace(currHost, newHost);

  if (
    window.location.pathname.includes("/download") ||
    window.location.pathname.includes("/invoice-download") ||
    window.location.pathname.includes("/subscriber") ||
    window.location.pathname.includes("/validate")
  ) {
    newUrl =
      newLocale === "fr"
        ? process.env.VUE_APP_FRENCH_PATH + `?p=${store.state.userID}`
        : process.env.VUE_APP_ENGLISH_PATH + `?p=${store.state.userID}`;
  }
  window.location.replace(newUrl);
};

const notifyHome = () => {
  store.commit("setAuth", false);
  router.push({ name: "HomePage", query: { p: store.state.userID } });
};
</script>

<style scoped>
@media screen and (max-width: 767px) {
  .title {
    font-size: 20px !important;
    margin-left: -15px;
  }
  .bell-logo-margin-left {
    margin-left: -15px;
  }
}
.navbar-color {
  background-color: rgb(0, 84, 154) !important;
}
.navbar-color img {
  filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(1000%);
}
@font-face {
  font-family: "bellslim_mediumregular";
  src: url("../assets/core/bellslim_medium-webfont.eot");
  src: url("../assets/core/bellslim_medium-webfont.eot?#iefix")
      format("embedded-opentype"),
    url("../assets/core/bellslim_medium-webfont.ttf") format("truetype"),
    url("../assets/core/bellslim_medium-webfont.svg#bellslim_mediumregular")
      format("svg");
  font-weight: normal;
  font-style: normal;
}

.title {
  font-family: "bellslim_mediumregular", Helvetica, Arial, sans-serif;
  font-size: 25px;
  font-weight: bold;
}
.top-nav-height {
  height: 33px;
}
.federal-bar-links {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
}
.federal-bar-links {
  font-size: 11px;
  color: #babec2;
  text-decoration: none;
}
</style>
